module.exports = __webpack_public_path__ + "img/Weapon_11.a519d3f7.png";